export enum QuizPageState {
    INFO = 'INFO',
    QUESTION = 'QUESTION',
    QUESTION_RESULT = 'QUESTION_RESULT'
}